import {useCallback} from 'react';
import {
  identifyUser,
  isAnalyticsLoaded,
  registerSuperProperties,
  resetAnalytics,
  track,
  unregisterSuperProperty,
  type AnalyticsProperties,
} from '@common-web/lib/analytics';

export function useAnalytics() {
  const loaded = isAnalyticsLoaded();

  return {
    isLoaded: loaded,
    track: useCallback((event: string, properties?: AnalyticsProperties) => {
      track(event, properties);
    }, []),
    identify: useCallback((distinctId: string, traits?: AnalyticsProperties) => {
      identifyUser(distinctId, traits);
    }, []),
    reset: useCallback(() => {
      resetAnalytics();
    }, []),
    register: useCallback((properties: AnalyticsProperties) => {
      registerSuperProperties(properties);
    }, []),
    unregister: useCallback((key: string) => {
      unregisterSuperProperty(key);
    }, []),
  };
}
